var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRoutePin = function SvgRoutePin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 60,
    fill: "none",
    viewBox: "0 0 48 60"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.75,
    d: "M47.625 23.704c0 3.174-1.46 7.009-3.702 11.01-2.236 3.992-5.222 8.101-8.215 11.812-2.992 3.709-5.985 7.01-8.23 9.386a156 156 0 0 1-3.472 3.557l-.006.006-.006-.006c-.175-.172-.432-.427-.76-.756-.654-.658-1.589-1.614-2.712-2.801-2.245-2.375-5.238-5.677-8.23-9.386-2.993-3.71-5.98-7.82-8.215-11.811C1.836 30.713.375 26.878.375 23.704.375 10.824 10.948.375 24 .375s23.625 10.449 23.625 23.329Z"
  })));
};
export default SvgRoutePin;